import React from "react";
import { useLocation } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const location = useLocation();

  // Hide footer on /generate page
  if (location.pathname === "/generate") return null;

  return (
    <footer className="footer light-text">
      <ul className="footer-links-text">
        <li><a className="footer-link-text" href="/resources-help">Resources</a></li>
        <li><a className="footer-link-text" href="/pricing-plans">Pricing</a></li>
        <li><a className="footer-link-text" href="/refund-policy">Refund Policy</a></li>
        <li><a className="footer-link-text" href="/faq-support">FAQ</a></li>
        <li><a className="footer-link-text" href="/privacypolicy">Privacy Policy</a></li>
        <li><a className="footer-link-text" href="/termsofservice">Terms Of Service</a></li> 
        <li><a className="footer-link-text" href="/contact-support">Contact&Support</a></li>
      </ul>
    </footer>
  );
};

export default Footer;